import { render, staticRenderFns } from "./FraisMedicaux.vue?vue&type=template&id=59b3f9e0&"
import script from "./FraisMedicaux.vue?vue&type=script&lang=js&"
export * from "./FraisMedicaux.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports